import type { Database } from '@backend/db'
import type { SupabaseClient } from '@supabase/supabase-js'
import { useMemo } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { createSupabaseClient } from '@/integrations/supabase/client'

let cachedClient: ReturnType<typeof createSupabaseClient> | null = null
let cachedTokenFn: (() => Promise<string | null>) | null = null

export const useSupabaseClient = (): SupabaseClient<Database> => {
  const { getToken } = useAuth()

  return useMemo(() => {
    if (!cachedClient || cachedTokenFn !== getToken) {
      cachedClient = createSupabaseClient(getToken)
      cachedTokenFn = getToken
    }
    return cachedClient
  }, [getToken])
}
